import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Table } from 'react-bootstrap';
import TPinModal from '../../../components/common/TPinModal';
import { showToast } from '../../../utils/toast';

const NetworkPayment = () => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [userDetails, setUserDetails] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [showTPinModal, setShowTPinModal] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    
    if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
      alert('Please enter a valid 10-digit mobile number');
      return;
    }

    setIsSearching(true);
    
    // Simulate API call
    setTimeout(() => {
      setUserDetails({
        name: 'John Doe',
        shopName: 'John Retail Mart',
        legalName: 'John Retail Pvt Ltd',
        mobile: mobileNumber,
        walletBalance: '5,250.00',
        amount: 1250,
        userType: 'Retailer',
        status: 'Active'
      });
      setIsSearching(false);
    }, 1000);
  };

  const handleTransferClick = () => {
    setShowTPinModal(true);
  };

  const handleVerifyTPin = async ({ tpin, amount }) => {
    // Simulate verification delay
    await new Promise((resolve) => setTimeout(resolve, 800));
    console.log('T-PIN verified:', tpin, 'Amount:', amount);
    setShowTPinModal(false);
    showToast.transactionSuccess('Transfer initiated successfully!');
  };

  return (
    <Container fluid className="network-payment-page p-4">
      <Row>
        <Col lg={10} xl={8} className="mx-auto">
          {/* Search Wallet User Card */}
          <Card className="shadow-sm border-0 mb-4">
            <Card.Body className="p-4" style={{ backgroundColor: '#f8f9fa' }}>
              <h4 className="mb-4" style={{ fontWeight: 600, color: '#333', fontSize: '20px' }}>
                Search Wallet User
              </h4>

              <Form onSubmit={handleSearch}>
                <Row className="align-items-end">
                  <Col xs={12} md={9}>
                    <Form.Group className="mb-0">
                      <div className="input-with-icon">
                        <i className="bi bi-phone input-icon" style={{ fontSize: '18px', color: '#8b5cf6' }}></i>
                        <Form.Control
                          type="text"
                          placeholder="Enter Mobile Number"
                          value={mobileNumber}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '');
                            setMobileNumber(value);
                          }}
                          maxLength={10}
                          className="ps-5"
                          style={{
                            padding: '12px 16px',
                            fontSize: '16px',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            backgroundColor: 'white'
                          }}
                          required
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={3}>
                    <Button
                      type="submit"
                      disabled={isSearching}
                      className="w-100"
                      style={{
                        backgroundColor: 'transparent',
                        border: '2px solid #0d6efd',
                        color: '#0d6efd',
                        padding: '12px 24px',
                        borderRadius: '8px',
                        fontWeight: 600,
                        fontSize: '15px',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = '#0d6efd';
                        e.currentTarget.style.color = 'white';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.style.color = '#0d6efd';
                      }}
                    >
                      {isSearching ? 'Searching...' : 'Search'}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>


          {/* User Details Table - Shows after search */}
          {userDetails && (
            <Card className="shadow-sm border-0">
              <Card.Body className="p-0">
                <div className="table-responsive">
                  <Table hover className="mb-0">
                    <thead style={{ backgroundColor: '#f8f9fa' }}>
                      <tr>
                        <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                          Name
                        </th>
                        <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                          Shop Name
                        </th>
                        <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                          Legal Name
                        </th>
                        <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                          Mobile Number
                        </th>
                        <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        style={{ transition: 'background-color 0.2s', cursor: 'pointer' }}
                        onClick={handleTransferClick}
                      >
                        <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>
                          {userDetails.name}
                        </td>
                        <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px', fontWeight: 500 }}>
                          {userDetails.shopName || 'N/A'}
                        </td>
                        <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px', fontWeight: 500 }}>
                          {userDetails.legalName || 'N/A'}
                        </td>
                        <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>
                          {userDetails.mobile}
                        </td>
                        <td style={{ padding: '12px 16px' }}>
                          <div className="transfer-btn-wrapper">
                            <Button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleTransferClick();
                              }}
                              className="transfer-btn"
                              variant="outline-success"
                            >
                              Transfer
                            </Button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          )}
        </Col>
      </Row>

      <TPinModal
        show={showTPinModal}
        onHide={() => setShowTPinModal(false)}
        onVerify={handleVerifyTPin}
        title="Confirm Transfer"
        message="Enter the amount and your T-PIN to authorize this transfer"
        requireAmount
        amountLabel="Transfer Amount"
        amountPlaceholder="Enter transfer amount"
        contextDetails={
          userDetails
            ? [
                { label: 'Name', value: userDetails.name },
                { label: 'Shop', value: userDetails.shopName || 'N/A' },
                { label: 'Mobile', value: userDetails.mobile }
              ]
            : []
        }
      />

      {/* Custom Styles */}
      <style jsx="true">{`
        .network-payment-page {
          background-color: #fff;
          min-height: calc(100vh - 100px);
        }

        .input-with-icon {
          position: relative;
        }

        .input-icon {
          position: absolute;
          left: 15px;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10;
          pointer-events: none;
        }

        .table tbody tr:hover {
          background-color: #f8f9fa;
        }

        .transfer-btn {
          padding: 8px 18px;
          font-size: 13px;
          font-weight: 600;
          border-radius: 6px;
          border: 2px solid #22c55e;
          background-color: transparent;
          color: #22c55e;
          transition: all 0.3s ease;
          box-shadow: none;
        }

        .transfer-btn:hover,
        .transfer-btn:focus {
          background-color: #22c55e;
          color: #fff;
          border-color: #22c55e;
        }

        .transfer-btn:active {
          background-color: #16a34a;
          border-color: #16a34a;
        }

        .transfer-btn:disabled,
        .transfer-btn.disabled {
          background-color: transparent;
          color: #9ca3af;
          border-color: #cbd5f5;
        }

        input:focus, textarea:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.15);
        }

        @media (max-width: 768px) {
          .table-responsive {
            overflow-x: auto;
          }
        }
      `}</style>
    </Container>
  );
};

export default NetworkPayment;

